import { render, staticRenderFns } from "./AppointmentAddWorker.vue?vue&type=template&id=f8b68314"
import script from "./AppointmentAddWorker.vue?vue&type=script&lang=ts"
export * from "./AppointmentAddWorker.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports